import EmotionalSR from 'libs/shared/ui/src/lib/components/my-evolution/emotional/emotional'

export const Emotional = () => {
  return (
    <div className="mt-10 w-full">
      <EmotionalSR />
    </div>
  )
}
